/**
 * Returns the URL of the page making the Algolia request (current page in browser).
 * Uses globalThis.location.href so the header stays correct during SPA navigation;
 * document.referrer would reflect the previous page load and be stale or empty.
 */
export const getAlgoliaRefererHeader = (): string => (globalThis as unknown as Window).location?.href ?? '';
